import React, { FC } from 'react';
import { ThemeProvider } from '@emotion/react';
import { theme as MyTheme } from '../../config/theme';
import { Stack } from '@mui/material';

interface MyFooterProps {}

const MyFooter: FC<MyFooterProps> = () => (
  <ThemeProvider theme={MyTheme}>
    <Stack sx={{backgroundColor: MyTheme.palette.primary.dark, color: "white"}} alignItems={"center"} py={2}>
      © 2025 Chun Yen Chang-Sundin.
    </Stack>
  </ThemeProvider>
);

export default MyFooter;
